/* lgp-buybox.js — turns the LP finder's "Show my pad" link into an on-page add to cart.
   Paired with snippets/lgp-buybox.liquid. 2026-10-29.

   Contract with lgp-finder.js (GENERATED — never hand-edit it):
     it calls go.setAttribute("href", "/products/<handle>?variant=<id>") whenever the
     brand/model/compound selection resolves, and restores a placeholder href when it does not.
   So we observe that one attribute instead of hooking its internals. If the finder is ever
   regenerated with different internals this keeps working, as long as the href contract holds.

   Deliberate:
   - The box is a SIBLING of the finder form, never a child: HTML forbids nested <form> and the
     parser silently drops the inner one, which deletes the add-to-cart. The sticky bottom bar is
     also a [data-lgf-form] with its own [data-lgf="go"], and has no sibling box, so it is
     untouched by design.
   - Product JSON is cached per handle. The finder re-fires on every compound change and we do
     not want a network round trip each time.
   - Out of stock hides the form rather than disabling the button, and offers the PDP link, so a
     sold-out variant can never produce a failed add. The old link-only behaviour sent people to
     a sold-out variant silently.
   - No free-sticker progress line here. The cart owns that claim on the existing $100 rung
     (snippets/cart-upsells.liquid, marker lg-sticker-reward); duplicating it on the page would
     be a second bar fed by separate logic. */
(function () {
  if (window.lgpBuyboxBound) return;
  window.lgpBuyboxBound = true;

  var cache = {};

  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    return '$' + n.toFixed(2);
  }

  function parseHref(href) {
    var m = /\/products\/([^?#\/]+)[^?]*\?[^#]*variant=(\d+)/.exec(href || '');
    return m ? { handle: m[1], vid: m[2] } : null;
  }

  function getProduct(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + handle + '.js', {
      headers: { Accept: 'application/json' }
    }).then(function (r) {
      if (!r.ok) throw new Error('product ' + r.status);
      return r.json();
    });
    return cache[handle];
  }

  function el(box, name) {
    return box.querySelector('[data-lgpbb="' + name + '"]');
  }

  function demote(box, on) {
    /* Style only. lgp-finder.js owns this button's textContent and rewrites it on every
       selection change, so a label swap here would be clobbered. */
    var form = box.getAttribute('data-lgpbb-for-id')
      ? document.getElementById(box.getAttribute('data-lgpbb-for-id'))
      : null;
    var go = (form || box.parentElement || document).querySelector('[data-lgf="go"]');
    if (!go) return;
    go.classList.toggle('lgpbb-demoted', !!on);
  }

  function hide(box) {
    box.hidden = true;
    demote(box, false);
  }

  function show(box, product, variant, handle) {
    var form = box.querySelector('[data-lgpbb-form]');
    var oos = el(box, 'oos');
    var img = el(box, 'img');

    /* Shopify titles carry a pack-size suffix after a pipe ("| 2 Pairs (4 Pads)",
       "| Front and Rear"). Drop it: it wraps the card to four lines, and "4 Pads" breaks the
       house rule that pack size is always said as pairs. The fine print below already says
       "Two pairs - front and rear". */
    var setTxt = function (n, v) { var e = el(box, n); if (e) e.textContent = v; };
    setTxt('title', String(product.title).split('|')[0].trim());
    setTxt('sub', variant.title && variant.title !== 'Default Title' ? variant.title : '');
    setTxt('price', money(variant.price));

    var src = variant.featured_image && variant.featured_image.src
      ? variant.featured_image.src
      : (product.featured_image || '');
    if (src && img) {
      img.src = src.replace(/(\.[a-z]+)(\?|$)/i, '_144x$1$2');
      img.alt = product.title;
      img.hidden = false;
    } else if (img) {
      img.hidden = true;
    }

    var vid = el(box, 'vid');
    if (variant.available) {
      if (vid) vid.value = variant.id;
      if (form) form.hidden = false;
      if (oos) oos.hidden = true;
    } else {
      /* Never offer an add that will fail. */
      if (vid) vid.value = '';
      if (form) form.hidden = true;
      setTxt('oostext', (box.getAttribute('data-oos-text') || 'Out of stock right now.') + ' ');
      var ol = el(box, 'ooslink');
      if (ol) ol.href = '/products/' + handle + '?variant=' + variant.id;
      if (oos) oos.hidden = false;
    }

    box.hidden = false;
    demote(box, true);
    /* Clarity: record this session at priority. A resolved variant is the signal that this
       visitor has intent; the other ~95% are ad-tap bounces that drown the replay quota. */
    try { if (typeof window.clarity === 'function') window.clarity('upgrade', 'finder-resolved'); } catch (e) {}
  }


  function update(go, box) {
    var parsed = parseHref(go.getAttribute('href'));
    if (!parsed) { hide(box); return; }
    getProduct(parsed.handle)
      .then(function (product) {
        var v = null;
        for (var i = 0; i < product.variants.length; i++) {
          if (String(product.variants[i].id) === String(parsed.vid)) { v = product.variants[i]; break; }
        }
        if (!v) { hide(box); return; }
        show(box, product, v, parsed.handle);
      })
      .catch(function () { hide(box); });
  }

  function bind() {
    var boxes = document.querySelectorAll('[data-lgp-buybox]');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      if (box.getAttribute('data-lgpbb-bound') === '1') continue;
      /* The box is a SIBLING of the finder form, never a child: HTML forbids nested <form>
         and the parser silently drops the inner one, which would delete the add-to-cart. */
      var prev = box.previousElementSibling;
      var form = (prev && prev.matches && prev.matches('[data-lgf-form]'))
        ? prev
        : (box.parentElement ? box.parentElement.querySelector('[data-lgf-form]') : null);
      if (!form) continue;
      var go = form.querySelector('[data-lgf="go"]');
      if (!go) continue;
      box.setAttribute('data-lgpbb-bound', '1');
      (function (g, b) {
        new MutationObserver(function () { update(g, b); })
          .observe(g, { attributes: true, attributeFilter: ['href'] });
        update(g, b);
      })(go, box);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  /* "$5 off your first order" opens the Klaviyo signup form on demand (its own trigger is a
     30 s delay). Klaviyo's documented hook: window._klOnsite.push(['openForm', id]). */
  document.addEventListener('click', function (evt) {
    var a = evt.target && evt.target.closest ? evt.target.closest('[data-kl-open]') : null;
    if (!a) return;
    evt.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', a.getAttribute('data-kl-open')]);
  });

})();
